module.exports={
	"Form": "AssetTypeViewManifest",
	"Scope": "AssetType-View",
	"Descriptors":
	{
		"AssetTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetType-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "AssetType-View-Identity",
				"Group": "AssetType-View-Identity"
			}
		},
		"AssetTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetType-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "AssetType-View-Details",
				"Group": "AssetType-View-Details"
			}
		},
		"AssetTypeDetails.IDAssetType":
		{
			"Name": "IDAsset Type",
			"Hash": "AssetType-View-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.GUIDAssetType":
		{
			"Name": "GUIDAsset Type",
			"Hash": "AssetType-View-GUIDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AssetType-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AssetType-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AssetType-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		},
		"AssetTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AssetType-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetType-View-DataAudit",
				"Group": "AssetType-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetType-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetType-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetType-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetType-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AssetType-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AssetType-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
